module.exports = __webpack_public_path__ + "assets/img/open.ad2a0472.svg";